import axios from "axios";
import { useEffect, useState } from "react";
import Dots from "react-activity/dist/Dots";
import "react-activity/dist/Dots.css";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import "./Home.scss";

function Home() {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://tell-me-more-backend-nyfc.onrender.com/form"
        );
        setData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error.response);
      }
    };
    fetchData();
  }, []);

  return isLoading ? (
    <div className="loader">
      <Dots />
    </div>
  ) : data.length === 0 ? (
    <div className="homeContainer">
      <h2>Aucun formulaire disponible 😞 </h2>
    </div>
  ) : (
    <div className="homeContainer">
      <h2>Répondre à un questionnaire</h2>

      {data.map((form, index) => {
        return (
          <div key={index} className="formBlock">
            <span>{form.title}</span>
            <Button
              text={"Go"}
              color={"green"}
              func={() => {
                navigate(`/form/${form.slug}`);
              }}
              show={true}
            />
          </div>
        );
      })}
      <p className="backofficeText">
        Créez votre propre questionnaire en cliquant sur BackOffice (mot de
        passe "admin")
      </p>
    </div>
  );
}

export default Home;
